
/**
 * Business admin notes model.
 */

export class BusinessAdminNote {
  /**
   * Id For Note
   */
  businessAdminNotesId: number;

  /**
   * Id For Business Associated with the Note
   */
  businessId: number;

  /**
   * Note content
   */
  note: string;

  /**
   * When the Note Was Created
   */
  updateDate: Date;

  /**
   * Who created the note (recId)
   */
  updateBy: string;

  static parse(data: any): BusinessAdminNote {
    return {
      businessAdminNotesId: data.businessAdminNotesId,
      businessId: data.businessId,
      note: data.note,
      updateDate: data.updateDate ? new Date(data.updateDate) : null,
      updateBy: data.updateBy
    };
  }
}
